import { defineMessages } from 'react-intl'

export default defineMessages({
    onDeleteConfirm: {
        id: 'containers.AgenciesPage.components.AgencyMembers.onDeleteConfirm',
        defaultMessage: 'Are you sure you want to remove {display_name}?',
    },
    onHeadChangeConfirm: {
        id: 'containers.AgenciesPage.components.AgencyMembers.onHeadChangeConfirm',
        defaultMessage: 'Are you sure you want to make {display_name} the head of the agency?',
    },
    deleteMemberTitle: {
        id: 'containers.AgenciesPage.components.AgencyMembers.deleteMemberTitle',
        defaultMessage: 'Remove member from agency',
    },
    changeAgencyHeadTitle: {
        id: 'containers.AgenciesPage.components.AgencyMembers.changeAgencyHeadTitle',
        defaultMessage: 'Make member head of agency',
    },
    duplicateAgencyHeadRates: {
        id: 'containers.AgenciesPage.components.AgencyMembers.duplicateAgencyHeadRates',
        defaultMessage: 'Duplicate agency head rates',
    },
    onDuplicateAgencyHeadRatesConfirm: {
        id: 'containers.AgenciesPage.components.AgencyMembers.onDuplicateAgencyHeadRatesConfirm',
        defaultMessage: "Are you sure you want to duplicate the Agency head's rates to {display_name}?",
    },
    ratesFullDuplicated: {
        id: 'containers.AgenciesPage.components.AgencyMembers.ratesFullDuplicated',
        defaultMessage: "Fully duplicated at {duplicated_at}",
    },
    ratesSomeDuplicated: {
        id: 'containers.AgenciesPage.components.AgencyMembers.ratesSomeDuplicated',
        defaultMessage: "Some duplicated at {duplicated_at}",
    },
    ratesNoneDuplicated: {
        id: 'containers.AgenciesPage.components.AgencyMembers.ratesNoneDuplicated',
        defaultMessage: "None duplicated",
    }
})